import { action } from 'mobx'
import { statistic } from '@util'
import { STATISTIC_LIVEMANAGE_PURCHASE } from '@constant'
export default class {
  /**
   * 埋点
   */
  @action
  sdk = () => {
    statistic(STATISTIC_LIVEMANAGE_PURCHASE)
  }
}
